// extracted by mini-css-extract-plugin
export var aircallIframe = "_hz-3";
export var fabContainer = "_hz-5";
export var fabRinging = "_hz-6";
export var loadingOverlay = "_hz-4";
export var pulse = "_hz-7";
export var widgetContent = "_hz-2";
export var widgetPanel = "_hz-0";
export var widgetPanelExpanded = "_hz-1";